import { cn } from "@/lib/utils";

export const INPUT_CLS =
  "ds-input flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2";

export const TEXTAREA_CLS = cn(INPUT_CLS, "h-auto min-h-[80px] resize-y");
